import { useMemo } from "react";
import { useSelector } from "react-redux";

const useWebsiteConfiguration = (configKey) => {
  // Get the entire website configuration state from Redux
  const configurations = useSelector((state) => state.websiteConfigurationReducer.configurations);

  // Retrieve the configuration value by key
  const configurationValue = useMemo(() => {
    try {
      const config = configurations.find((c) => c.key === configKey);
      return config ? JSON.parse(config.value) : {};
    } catch (error) {
      console.error(`Error parsing configuration for key: ${configKey}`, error);
      return {};
    }
  }, [configurations, configKey]);

  return configurationValue;
};

export default useWebsiteConfiguration;
